import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { HomeComponent } from './components/home/home.component';
import { RegisterComponent } from './components/register/register.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { DashboardComponent } from './components/superadmin/dashboard/dashboard.component';
import { SuperadminLoginComponent } from './components/superadmin/superadmin-login/superadmin-login.component';
import { CallcenterLoginComponent } from './components/callcenter/callcenter-login/callcenter-login.component';
import { CallcenterDashboardComponent } from './components/callcenter/callcenter-dashboard/callcenter-dashboard.component';

const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'welcome', component: WelcomeComponent },
  { path: 'home', component: HomeComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'superadmin/dashboard', component: DashboardComponent },
  { path: 'superadmin/login', component: SuperadminLoginComponent },
  { path: 'callcenter', component: CallcenterLoginComponent },
  { path: 'callcenter/dashboard', component: CallcenterDashboardComponent },
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
